<template>
        <div class="table-responsive table-fix-head" style="max-height: 350px; overflow-y: auto">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th style="width: 80px;">ID</th>
                    <th>Title</th>
                    <th style="max-width: 400px;">Categories</th>
                    <th style="width: 140px;">States</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="j in jobs">
                    <td>{{ j.id }}</td>
                    <td>{{ j.title }}<br>
                        <i>{{ j.admin_description }}</i>
                    </td>
                    <td>
                        <div v-for="tag in j.categories" style="display:inline-block; margin-bottom:5px;">
                            <span class="label"
                                  :class="{ 'label-default' : (tag != 'Owner Operators'), 'label-primary' : (tag == 'Owner Operators') }"
                                  style="margin-right:5px">{{ tag }}</span>
                        </div>
                    </td>
                    <td>{{ j.state_code_list }}<br>
                        States: {{ j.state_count }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
</template>

<script>
    export default {
        props: [
            'job_ids',
            'employer_id'
        ],
        data() {
            return {
                jobs: []
            };
        },
        watch: {
            job_ids() {
                this.refresh()
            }
        },
        methods: {
            refresh() {
                return axios.post(url(`admin/employer/${this.employer_id}/job-ids-list`), {
                        'job_ids': this.job_ids
                    }).then(response => {
                        this.jobs = response.data.jobs;
                    });
            }
        },
        mounted() {
            this.refresh();
        },
    };
</script>